import { clearAllWatchSyncV2LocalState } from '../services/watchSyncV2Repository';
import { clearEpgCache } from '../api/epgCache';
import { clearBrowserCacheStorage } from './cacheUtils';

const ACTIVATION_KEYS = new Set([
  'ott_device_v1',
  'ott_hw_uid',
  'ott_playlist_activation_url_v1',
]);

export async function clearApplicationDataPreservingActivation(): Promise<void> {
  await Promise.all([clearEpgCache(), clearBrowserCacheStorage()]);
  clearAllWatchSyncV2LocalState();
  const preserved = new Map<string, string>();
  ACTIVATION_KEYS.forEach((key) => {
    try {
      const value = localStorage.getItem(key);
      if (value != null) preserved.set(key, value);
    } catch {
      // Continue clearing what is available.
    }
  });
  try { localStorage.clear(); } catch { /* ignore */ }
  preserved.forEach((value, key) => {
    try { localStorage.setItem(key, value); } catch { /* ignore */ }
  });
  try { sessionStorage.clear(); } catch { /* ignore */ }
}

export function closeOrRestartApplication(): void {
  const runtime = window as any;
  try {
    if (runtime.AndroidBridge?.exitApp) {
      runtime.AndroidBridge.exitApp();
      return;
    }
  } catch { /* try the next platform */ }

  try {
    if (runtime.tizen?.application?.getCurrentApplication) {
      runtime.tizen.application.getCurrentApplication().exit();
      return;
    }
  } catch { /* try the next platform */ }

  try {
    if (runtime.webOS?.platformBack) {
      runtime.webOS.platformBack();
      return;
    }
  } catch { /* browser fallback below */ }

  // Browsers generally refuse scripts closing their own tab. Reloading returns
  // to a clean boot while retaining only device activation identity.
  window.location.reload();
}
